import { useLocation, useNavigate } from "react-router-dom";

interface TableRowProps {
  columns: any;
  row: any;
  onRowClick?: (row: any) => void;
}

const TableRow: React.FC<TableRowProps> = ({
  columns,
  row,
  onRowClick,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const payload = location.state?.payload;

  const handleRedirect = (x: string): void => {
    navigate("/actualizar-datos/condiciones-medicas-formulario", {
      state: { payload: payload },
    });
  };

  const colores = {
    Vigente: "green",
    Inactivo: "red",
  };

  return (
    <>
      {columns.map((column: any, index: number) =>
        column.tipo === "button" ? (
          <div className="cfamilia_box" key={index}>
            <button
              onClick={() => onRowClick && onRowClick(row)}
              className="button is-tabla w-button"
            >
              Ver más
            </button>
          </div>
        ) : (
          <div className="cfamilia_box" key={index}>
            {column.tipo === 'status' && <span className={"circle-" + (row[column.key] === 'Vigente' ? 'green' : 'red')}></span>}
            <div key={index}>{row[column.key]}</div>
          </div>
        )
      )}
    </>
  );
};

export default TableRow;
